module.exports = new __parcel__URL__("plasma_cannon_level_2_skin.98df2e0f.png").toString();